import React from "react";
import BaseReactSelectDropdown from "./BaseReactSelectDropdown";
import { type DropdownProps } from "../models";

interface Option {
  value: number;
  label: string;
}

const options: Option[] = [];
for (let i = 0; i <= 50; i++) {
  options.push({ value: i, label: `+${i}` });
}

const getOption = (value: number): Option | undefined => {
  return options.find(o => o.value === value);
}

const GuestlistBringsXDropdown = (props: DropdownProps<number>) => {
  const selectedOption = getOption(props.value);

  return <BaseReactSelectDropdown
    excludeKeys={[]}
    options={options}
    getLabel={v => v.label}
    getValue={(v) => v.value}
    value={selectedOption}
    onChange={(v) => props.onChange(v.value)}
    onEsc={props.onEsc}
    config={{
      ...props.config
    }}
  />;
};

export default GuestlistBringsXDropdown;